import React from 'react';
import { Box, List } from '@mui/material';
import { styled } from '@mui/material/styles';
import ValueItem from './ValueItem';

const Root = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0.5),
  },
}));

const StyledList = styled(List)(({ theme }) => ({
  width: '100%',
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    '& > *:not(:last-child)': {
      marginBottom: theme.spacing(1),
    },
  },
}));

const ValueList = ({ category, onValueSelect }) => {
  if (!category || !category.questions) {
    return null;
  }

  return (
    <Root>
      <StyledList>
        {category.questions.map((question, index) => (
          <ValueItem
            key={`${category.label}-${index}`}
            question={question}
            onSelect={() => onValueSelect(question)}
          />
        ))}
      </StyledList>
    </Root>
  );
};

export default ValueList; 